import { GroupeManagement } from '@repo/ui/features/groupe/index';

export default function GroupePage() {
  return <GroupeManagement />;
}
